<template lang="html">



  <svg id="pe_svg_logo11" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 309 301">

<path class="cls-pe-1" d="m274.16,6.74H25.84C15.29,6.74,6.74,15.29,6.74,25.84v248.32c0,10.55,8.55,19.1,19.1,19.1h248.32c10.55,0,19.1-8.55,19.1-19.1V25.84c0-10.55-8.55-19.1-19.1-19.1Z"/>
<path class="cls-pe-2" d="m274.16,300H25.84c-14.25,0-25.84-11.59-25.84-25.84V25.84C0,11.59,11.59,0,25.84,0h248.32c14.25,0,25.84,11.59,25.84,25.84v248.32c0,14.25-11.59,25.84-25.84,25.84ZM25.84,13.48c-6.82,0-12.36,5.54-12.36,12.36v248.32c0,6.82,5.54,12.36,12.36,12.36h248.32c6.82,0,12.36-5.54,12.36-12.36V25.84c0-6.82-5.54-12.36-12.36-12.36H25.84Z"/>
<rect class="cls-pe-wordsearch" x="80.55" y="80.55" width="69.45" height="69.45"/><path class="cls-2" d="m154.36,154.36h-78.16v-78.16h78.16v78.16Zm-69.45-8.71h60.74v-60.74h-60.74v60.74Z"/>
<rect class="cls-pe-wordsearch" x="80.55" y="11.09" width="69.45" height="69.45"/><path class="cls-2" d="m154.36,84.9h-78.16V6.74h78.16v78.16Zm-69.45-8.71h60.74V15.45h-60.74v60.74Z"/>
<rect class="cls-pe-wordsearch" x="11.09" y="80.55" width="69.45" height="69.45"/><path class="cls-2" d="m84.9,154.36H6.74v-78.16h78.16v78.16Zm-69.45-8.71h60.74v-60.74H15.45v60.74Z"/>
<rect class="cls-pe-wordsearch" x="150" y="80.55" width="69.45" height="69.45"/><path class="cls-2" d="m223.81,154.36h-78.16v-78.16h78.16v78.16Zm-69.45-8.71h60.74v-60.74h-60.74v60.74Z"/>
<rect class="cls-pe-wordsearch" x="219.45" y="80.55" width="69.45" height="69.45"/><path class="cls-2" d="m293.26,154.36h-78.16v-78.16h78.16v78.16Zm-69.45-8.71h60.74v-60.74h-60.74v60.74Z"/>
<rect class="cls-pe-wordsearch" x="80.55" y="150" width="69.45" height="69.45"/><path class="cls-2" d="m154.36,223.81h-78.16v-78.16h78.16v78.16Zm-69.45-8.71h60.74v-60.74h-60.74v60.74Z"/>
<rect class="cls-pe-wordsearch" x="80.55" y="219.45" width="69.45" height="69.45"/><path class="cls-2" d="m154.36,293.26h-78.16v-78.16h78.16v78.16Zm-69.45-8.71h60.74v-60.74h-60.74v60.74Z"/>
<path class="cls-pe-3" d="m115.27,130.66c-6.7-3.73-17.18-13.41-16.75-22.01.44-8.88,11.82-12.67,16.75-3.41,4.93-9.26,16.3-5.48,16.75,3.41.43,8.6-10.04,18.28-16.75,22.01Z"/>
</svg>
</template>

<script lang="js">

  export default  {
    name: 'wordsearch',
  }

</script>
<style>.cls-pe-1{fill:#ffffff;}.cls-pe-2,.cls-pe-3{fill:#222;}.cls-pe-3{fill-rule:evenodd;}.cls-pe-wordsearch{fill:#d879e0;}
            
</style>

